import Vue from "vue";
import { TypePageErreur } from "../../shared/models/typePageErreur";
import { Prop, Component } from "vue-property-decorator";

@Component
export default class ErreurEcran extends Vue {
	@Prop({ type: String, required: false })
	public type!: TypePageErreur;

	public errorMessage = "";

	public mounted(): void {
		let error = Number(this.$route.params.id);

		if (this.type) {
			error = this.type;
		}

		switch (error) {
			case TypePageErreur.SSO:
				this.errorMessage = "Vous n'êtes pas autorisé à vous connecter.<br/> Rapprochez-vous de votre administrateur afin qu'il associe votre compte SSO à votre profil salarié afin de vous donner les accès..";
				break;
			case TypePageErreur.ListeSocietes:
				this.errorMessage = "Vous n'avez pas de contrat actif, veuillez vous rapprocher de votre gestionnaire de paie.";
				break;
			case TypePageErreur.SalarieConnecte:
				this.errorMessage = "Vous n'êtes pas rattaché à un salarié, veuillez vous rapprocher de votre gestionnaire de paie.";
				break;
			default:
				this.errorMessage = "Une erreur est survenue, veuillez vous rapprocher de votre gestionnaire de paie.";
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/ecranErreur/erreurEcran.ts